
import { motion, AnimatePresence} from 'motion/react'
import Avatar from '../Avatar/Avatar';

import { FaCode } from "react-icons/fa";
import { FiDatabase } from "react-icons/fi"
import { MdOutlineSecurity } from "react-icons/md";
import { GrSystem } from "react-icons/gr";

import './CardProfissionais.css'
export default function CardProfissionais({p}){

        const icone = (tipo) =>{
        switch(tipo){
            case 'BD':
                return <FiDatabase color="var(--azul-medio)" size={18} />
            case 'code':
                return <FaCode color="var(--azul-medio)" size={18} />
            case 'infra':
                return <MdOutlineSecurity color="var(--azul-medio)" size={18} />
            case 'sys':
                return <GrSystem color="var(--azul-medio)" size={18} />
            default:
                return <FiDatabase color="var(--azul-medio)" size={18} />
            
        }
    }


    return(
        <motion.div 
            className="cardsSobreNos flex"
            initial='initial'
            whileHover='hover'

            variants={{
                initial:{scale:1.0},
                hover:{scale:1.03, border:'1px solid var(--azul-escuro)', backgroundColor:"var(--azul-escuro)"}
            }}
            >
                        
                <motion.div
                    variants={{
                        initial: {rotate:0},
                        hover:{rotate:-5,scale:1.2, paddingRight:5, border:"1px solid var(--azul-medio)"}
                    
                    }}
                    style={{borderRadius:20, width:"108px"}}
                    >
                    <Avatar className='profissionais' nome={p.profissional} />
                </motion.div>

                <div className="textSobreNos"> 
                    <h2 key={p.id}>{p.profissional}</h2>

                    <div className="flex">
                        <div>{icone(p.icone)}</div>
                        <p className="oQueFaz">{p.oQueFaz}</p>
                    </div>

                    <AnimatePresence>
                        <motion.div
                            key={p.id}
                            className="descricao"
                            variants={{
                                initial: {
                                    y: "100%",
                                    opacity: 0
                                },
                                hover: {
                                    y: 0,
                                    opacity: 1
                                }
                            }}
                        transition={{ duration: 0.3 }}
                    >   
                        <h2>{p.profissional}</h2> 
                        <p className="destaque">{p.oQueFaz}</p>
                        <p>
                            {p.trabalho}
                        </p>
                        </motion.div>
                    </AnimatePresence>

                </div>
        </motion.div>
    )
}